import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import ProgressiveImage from 'react-progressive-image';

class ProjectSlide extends PureComponent {
  render() {
    const {
      project, slider, canTap, history,
    } = this.props;
    const {
      id, title, subtitle, image, tiny,
    } = project;
    return (
      <div className="project_slide">
        <div
          role="presentation"
          className="project_slide__link"
          onClick={() => {
            if (slider.canTapSlide || canTap) {
              history.push(`/info/${id}`);
            } else {
              slider.canTapSlide = true;
            }
          }}
        >
          <ProgressiveImage src={image} placeholder={tiny}>
            {(src, loading) => (
              <div style={{ opacity: loading ? 0.5 : 1 }}>
                <img className="project_slide__image" src={src} alt={title} />
              </div>
            )}
          </ProgressiveImage>

          <div className="project_slide__bottom">
            <div className="font-title-bold  project_slide__bottom__title">{title}</div>
            <div className="font-title-medium project_slide__bottom__subtitle">{subtitle}</div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(ProjectSlide);



// WEBPACK FOOTER //
// ./src/components/Sliders/ProjectSlide.js